export default __webpack_public_path__ + "static/media/gr.7fb601ef.svg";